import * as ScrollMagic from "scrollmagic";
import { TweenMax, TimelineMax } from "gsap";
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";
import counterUp from 'counterup2'
require('waypoints/lib/noframework.waypoints.js')
import Swiper from 'swiper';
import { Navigation, EffectFade, Autoplay } from 'swiper/modules';
import '../sass/about.sass';
import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { 
    faPlus,
    faAngleRight,
    faAngleLeft,
    faMinus,
    // 以下共用
    faEnvelope,
    faGlobe,
    faArrowUp,
    faChevronRight,
} from '@fortawesome/free-solid-svg-icons'
import { 
    // 以下共用
    faFacebookF,
    faYoutube,
    faXTwitter,
    faInstagram,
    faLinkedinIn,
} from '@fortawesome/free-brands-svg-icons'

library.add(
    faPlus, 
    faAngleRight, 
    faAngleLeft, 
    faMinus,
    faEnvelope,
    faGlobe,
    faArrowUp,
    faChevronRight,
    faFacebookF,
    faYoutube,
    faXTwitter,
    faInstagram,
    faLinkedinIn,)
dom.watch()




ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
var controller = new ScrollMagic.Controller();


//門打開動畫
new ScrollMagic.Scene({ triggerElement: ".about-overview" })
    .setTween(".about-overview .bg", 1.5, { opacity: 0.8, scale: 1.1 })
    .addTo(controller);
new ScrollMagic.Scene({ triggerElement: ".about-overview" })
    .setTween(".door_right", 2, { right: "-75px" })
    .addTo(controller);
new ScrollMagic.Scene({ triggerElement: ".about-overview" })
    .setTween(".door_left", 2, { left: "-75px" })
    .addTo(controller);
new ScrollMagic.Scene({ triggerElement: ".about-overview" })
    .setTween(".guard_right", 2, { right: "-10px", bottom: "-5px" })
    .addTo(controller);
new ScrollMagic.Scene({ triggerElement: ".about-overview" })
    .setTween(".guard_left", 2, { left: "-10px", bottom: "-5px" })
    .addTo(controller);
new ScrollMagic.Scene({ triggerElement: ".about-overview" })
    .setTween(".about-overview .txt img", 1, { top: "0px", opacity: 1 })
    .addTo(controller);
new ScrollMagic.Scene({ triggerElement: ".about-overview" })
    .setTween(".about-overview .txt b", 1, { top: "0px", opacity: 1 })
    .addTo(controller);
new ScrollMagic.Scene({ triggerElement: ".about-overview" })
    .setTween(".about-overview .txt h3", 1, { top: "0px", opacity: .8 })
    .addTo(controller);
new ScrollMagic.Scene({ triggerElement: ".about-overview" })
    .setTween(".about-nav", .5, { bottom: "0px", opacity: 1, delay: 0.2 })
    .addTo(controller);



//關於皇家 動畫
new ScrollMagic.Scene({ triggerElement: "#aboutRSG" })
    .setTween(".bg_sky ", .5, { opacity: 1 })
    .addTo(controller);
new ScrollMagic.Scene({ triggerElement: "#aboutRSG p", duration: 1000 })
    .setTween("#aboutRSG .main-tit", { y: "-4vw" })
    .addTo(controller);
new ScrollMagic.Scene({ triggerElement: "#aboutRSG p", duration: 1000 })
    .setTween("#aboutRSG p", { y: "2vw" })
    .addTo(controller);
new ScrollMagic.Scene({ triggerElement: "#aboutRSG" })
    .setTween(".a-info-img", 1, { x: "-2vw" })
    .addTo(controller);
new ScrollMagic.Scene({ triggerElement: "#aboutRSG" })
    .setTween(".bg_gold_behind", 1, { x: "2vw" })
    .addTo(controller);
new ScrollMagic.Scene({ triggerElement: "#aboutRSG" })
    .setTween(".bg_gold_front", 1, { x: "3.5vw" })
    .addTo(controller);



//服務範疇 動畫
new ScrollMagic.Scene({ triggerElement: "#aboutServices .bg", duration: 2000 })
    .setTween("#aboutServices .bg", 1, { x: "-3vw" })
    .addTo(controller);
new ScrollMagic.Scene({ triggerElement: "#aboutServices .bg" })
    .setTween(".as01", .5, { x: "-2vw" })
    .addTo(controller);
new ScrollMagic.Scene({ triggerElement: "#aboutServices .bg" })
    .setTween(".as02", .5, { x: "-1vw" })
    .addTo(controller);
new ScrollMagic.Scene({ triggerElement: "#aboutServices .bg" })
    .setTween(".as04", .5, { x: "1vw" })
    .addTo(controller);
new ScrollMagic.Scene({ triggerElement: "#aboutServices", duration: 1000 })
    .setTween("#aboutServices .main-tit", { y: "-2vw" })
    .addTo(controller);
new ScrollMagic.Scene({ triggerElement: "#aboutServices", duration: 1000 })
    .setTween("#aboutServices .swiper-container", { y: "-2vw" })
    .addTo(controller);
new ScrollMagic.Scene({ triggerElement: "#aboutServices", duration: 1000 })
    .setTween("#aboutServices .relative-btn", { y: "-2vw" })
    .addTo(controller);



//遊戲特色 動畫
new ScrollMagic.Scene({ triggerElement: "#aboutFeatures" })
    .setTween("#aboutFeatures .bg ", .5, { opacity: 1 }) // trigger a TweenMax.to tween
    .addTo(controller);
new ScrollMagic.Scene({ triggerElement: "#aboutFeatures .img" })
    .setTween(".slate07", .5, { y: "0", opacity: 1 })
    .addTo(controller);
new ScrollMagic.Scene({ triggerElement: "#aboutFeatures .img" })
    .setTween(".slate08", .5, { y: "0", opacity: 1, delay: .1 })
    .addTo(controller);
new ScrollMagic.Scene({ triggerElement: "#aboutFeatures .img" })
    .setTween(".slate09", .5, { y: "0", opacity: 1, delay: .2 })
    .addTo(controller);
new ScrollMagic.Scene({ triggerElement: "#aboutFeatures .img" })
    .setTween(".slate04", .5, { y: "0", opacity: 1, delay: .1 })
    .addTo(controller);
new ScrollMagic.Scene({ triggerElement: "#aboutFeatures .img" })
    .setTween(".slate05", .5, { y: "0", opacity: 1, delay: .2 })
    .addTo(controller);
new ScrollMagic.Scene({ triggerElement: "#aboutFeatures .img" })
    .setTween(".slate06", .5, { y: "0", opacity: 1, delay: .3 })
    .addTo(controller);
new ScrollMagic.Scene({ triggerElement: "#aboutFeatures .img" })
    .setTween(".slate01", .5, { y: "0", opacity: 1, delay: .2 })
    .addTo(controller);
new ScrollMagic.Scene({ triggerElement: "#aboutFeatures .img" })
    .setTween(".slate02", .5, { y: "0", opacity: 1, delay: .3 })
    .addTo(controller);
new ScrollMagic.Scene({ triggerElement: "#aboutFeatures .img" })
    .setTween(".slate03", .5, { y: "0", opacity: 1, delay: .4 })
    .addTo(controller);
new ScrollMagic.Scene({ triggerElement: "#aboutFeatures .img" })
    .setTween(".kid", .3, { y: "0", opacity: 1, delay: .5 })
    .addTo(controller);
new ScrollMagic.Scene({ triggerElement: "#aboutFeatures", duration: 1000 })
    .setTween(".main-flow", .5, { y: "-10%", })
    .addTo(controller);


// 合作夥伴 動畫
new ScrollMagic.Scene({ triggerElement: ".partner_bg", duration: 1000 })
    .setTween(".partner_bg", .5, { y: "20%", })
    .addTo(controller);




$(function() {


    //數字動畫
    const el = document.querySelector('.counter1')
    new Waypoint({
        element: el,
        handler: function() {
            counterUp(el)
            this.destroy()
        },
        offset: 'bottom-in-view',
    })
    const el2 = document.querySelector('.counter2')
    new Waypoint({
        element: el2,
        handler: function() {
            counterUp(el2)
            this.destroy()
        },
        offset: 'bottom-in-view',
    })
    const el3 = document.querySelector('.counter3')
    new Waypoint({
        element: el3,
        handler: function() {
            counterUp(el3)
            this.destroy()
        },
        offset: 'bottom-in-view',
    })
    const el4 = document.querySelector('.counter4')
    new Waypoint({
        element: el4,
        handler: function() {
            counterUp(el4)
            this.destroy()
        },
        offset: 'bottom-in-view',
    })
    const el5 = document.querySelector('.counter5')
    new Waypoint({
        element: el5,
        handler: function() {
            counterUp(el5)
            this.destroy()
        },
        offset: 'bottom-in-view',
    })
    const el6 = document.querySelector('.counter6')
    new Waypoint({
        element: el6,
        handler: function() {
            counterUp(el6)
            this.destroy()
        },
        offset: 'bottom-in-view',
    })
    const el7 = document.querySelector('.counter7')
    new Waypoint({
        element: el7,
        handler: function() {
            counterUp(el7)
            this.destroy()
        },
        offset: 'bottom-in-view',
    })


    var swiper = new Swiper('#aboutServices .swiper-container', {
        speed: 1000,
        loop: true,
        parallax: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 3000,
        },
        centeredSlides: true,
        grabCursor: true,
        navigation: {
            nextEl: '#aboutServices .swiper-button-next',
            prevEl: '#aboutServices .swiper-button-prev'
        },
        modules: [Navigation, EffectFade, Autoplay],

    })

    $('.accordion .icon,.accordion .tit').on('click', function() {
        if ($(this).parent('.items').hasClass('active')) {

            $(this).parent('.items').removeClass('active')
            $(this).parent('.items').find('.contnt').slideUp()

        } else {

            $('.accordion .items').removeClass('active')
            $(this).parent('.items').addClass('active')
            $('.accordion .contnt').slideUp()
            $(this).parent('.items').find('.contnt').slideDown()

        }
    })

    $('a.scrollto').click(function() {
        var linkTarget = $(this.hash);
        //alert(linkTarget.offset().top);
        $('html,body').stop(true, false).animate({
            scrollTop: linkTarget.offset().top
        }, 1000);
        return false;

    });



})